export const contactDefault = [
  { type: 'community', priority: '1' },
  { type: 'resolution', priority: '2' },
  { type: 'business', priority: '3' },
  { type: 'contact', priority: '4' },
];

export const contactTechnical = [
  { type: 'community', priority: '1' },
  { type: 'developer', priority: '2' },
  { type: 'braintree', priority: '3' },
  { type: 'site', priority: '4' },
  { type: 'contact', priority: '5' },
];

export const contactMapping = {
  callus: 'call-us',
  email: 'email-us',
  seller: 'resolution',
  community: 'community',
  chat: 'chat',
  livechatgrayedout: 'liveChatGrayedOut',
  message: 'messageUs',
  schedulecallback: 'scheduleCallBack',
};

export const complaintsContactDefault = [
  { type: 'help_center', priority: '1' },
  { type: 'community', priority: '2' },
  { type: 'resolution', priority: '3' },
  { type: 'contact', priority: '4' },
];
